export const isProductionEnv = process.env.REACT_APP_FRONT_BUILD_ENV === 'production';
export const isDevEnv = process.env.REACT_APP_FRONT_BUILD_ENV === 'development';
export const stripeDashboardUrl = isDevEnv ? 'https://dashboard.stripe.com/test' : 'https://dashboard.stripe.com';
export const googleServiceEmail = process.env.REACT_APP_GOOGLE_SERVICE_EMAIL;

export * from './api';
export * from './menus';
